import request from '@/utils/httpRequest'

export default class noticeService {
    querynoticeById(id) {
        return request({
            url: '/small/wuyeSmallNotification/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/small/wuyeSmallNotification/startFlow',
            method: 'post',
            data: params
        })
    }
}   
